export const messages = {
  en: {
    openApiAuth: {
      title: 'Open API Application Management',
      appId: 'Application ID',
      appName: 'Application Name',
      appKey: 'App Key',
      status: 'Status',
      enabled: 'Enabled',
      disabled: 'Disabled',
      createTime: 'Creation Time',
      remark: 'Remarks',
      fetchError: 'Failed to fetch applications',
      addSuccess: 'Added successfully',
      updateSuccess: 'Updated successfully',
      deleteSuccess: 'Deleted successfully',
      merchantName: 'Merchant Name',
      merchantAddress: 'Merchant Address',
      selectMerchant: 'Select Merchant'
    }
  },
  zh: {
    openApiAuth: {
      title: '开放API应用管理',
      appId: '应用ID',
      appName: '应用名称',
      appKey: 'App Key',
      status: '状态',
      enabled: '启用',
      disabled: '禁用',
      createTime: '创建时间',
      remark: '备注',
      fetchError: '获取应用列表失败',
      addSuccess: '添加成功',
      updateSuccess: '更新成功',
      deleteSuccess: '删除成功',
      merchantName: '商家名称',
      merchantAddress: '商家地址',
      selectMerchant: '请选择商家'
    }
  }
}